module.exports = __webpack_public_path__ + "img/c-thermometer-img8-1.eb170746.png";